import type { IconName } from '../components/Icon';

// Section lists the shell's navigation needs. Kept apart from the pages themselves so the shell does not
// pull the admin and settings pages into the first download (they load when opened).

export type AdminTab = 'users' | 'reports' | 'invites' | 'schools' | 'usernames' | 'site' | 'appearance' | 'system' | 'config' | 'audit' | 'security' | 'ai';

export const ADMIN_TABS: AdminTab[] = ['system', 'users', 'reports', 'invites', 'schools', 'usernames', 'site', 'appearance', 'config', 'audit', 'security', 'ai'];
export const ADMIN_TAB_PERMISSION: Record<AdminTab, string> = {
  users: 'users.read',
  reports: 'reports.manage',
  invites: 'invites.manage',
  schools: 'schools.verify',
  usernames: 'usernames.manage',
  site: 'site.manage',
  appearance: 'site.manage',
  system: 'system.read',
  config: 'config.manage',
  audit: 'audit.read',
  security: 'security.read',
  ai: 'ai.read',
};
export const ADMIN_TAB_ICONS: Record<AdminTab, IconName> = {
  system: 'activity',
  users: 'users',
  reports: 'flag',
  invites: 'ticket',
  schools: 'learn',
  usernames: 'user',
  site: 'template',
  appearance: 'palette',
  config: 'sliders',
  audit: 'list',
  security: 'alert',
  ai: 'ai',
};
export const adminTabsFor = (permissions: readonly string[]) => ADMIN_TABS.filter((x) => permissions.includes(ADMIN_TAB_PERMISSION[x]));

export const SETTINGS_SECTIONS = ['account', 'appearance', 'privacy', 'notifications', 'security', 'devices'] as const;
export type SettingsSection = (typeof SETTINGS_SECTIONS)[number];
export const SETTINGS_ICONS: Record<SettingsSection, IconName> = {
  account: 'user',
  appearance: 'palette',
  privacy: 'shield',
  notifications: 'bell',
  security: 'key',
  devices: 'monitor',
};
